import type {TreePane} from '@github-ui/repos-file-tree-view'
import {createContext, use, useMemo} from 'react'

type TreePaneContextValue = TreePane & {
  onFindFilesShortcut: () => void
}

const TreePaneContext = createContext<TreePaneContextValue | null>(null)

export function TreePaneProvider({
  children,
  treePaneState,
  onFindFilesShortcut,
}: {
  children: React.ReactNode
  treePaneState: TreePane
  onFindFilesShortcut: () => void
}) {
  const {isTreeExpanded, expandTree, collapseTree, treeToggleElement, treeToggleRef, searchBoxRef} = treePaneState
  const value = useMemo(
    () => ({
      isTreeExpanded,
      expandTree,
      collapseTree,
      treeToggleElement,
      treeToggleRef,
      searchBoxRef,
      onFindFilesShortcut,
    }),
    [isTreeExpanded, expandTree, collapseTree, treeToggleElement, treeToggleRef, searchBoxRef, onFindFilesShortcut],
  )
  return <TreePaneContext value={value}>{children}</TreePaneContext>
}

export function useTreePaneContext() {
  const context = use(TreePaneContext)
  if (!context) {
    throw new Error('useTreePaneContext must be used within TreePaneProvider')
  }
  return context
}
